<template>
  <div class="bk-small-box flex-row">
    <div class="bk-small-box-item" v-for="(item, index) in state?.musicData" :key="index.toString()">
      <div class="audio-box">
        <AudioPlayer
          :ref="
            (el) => {
              stateData[`refPlayer${index}`] = el
            }
          "
          :url="`${item.mp3_url}`"
          :duration="item.duration_milliseconds / 1000"
          @syncDuration="syncDuration"
          @syncPlayState="(playState) => syncPlayState(playState, index)"
          @syncLoadingState="syncLoadingState"
          @syncProgress="syncProgress"
        >
          <div
            class="bkimg"
            :class="{
              active: currentMusic.currentIndex == index && currentMusic.isplay,
            }"
          >
            <MusicPause v-if="currentMusic.currentIndex == index && currentMusic.isplay" />
          </div>
          <div
            class="ic-music"
            :class="[`ic-music-bk-${index}`, `${currentMusic.currentIndex == index && currentMusic.isplay ? 'active' : ''}`]"
            @click.stop="
              () => {
                doTogglePlay(index)
              }
            "
          >
          <!-- :class="{
              active: currentMusic.currentIndex == index && currentMusic.isplay,
            }" -->
            <div class="ic-play-off"></div>
          </div>
        </AudioPlayer>
      </div>
      <div class="music-desc">{{ index == 0 ? $$t("credit.reference") : $$t("credit.generated") }}</div>
    </div>
  </div>
</template>
<script setup>
import { reactive, defineEmits, getCurrentInstance } from "vue"
import AudioPlayer from "@/components/media/audioPlayer/AudioPlayer.vue"
import MusicPause from "./musispause.vue"
import { $$t, $$language } from "@/i18n/i18n.js"
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js"

const emits = defineEmits(["autoscroll"])

const props = defineProps({
  process_similar_show: {
    type: Number,
    default: 0,
  },
  process_similar_animate: {
    type: Number,
    default: 0,
  },
})

const stateData = {
  refPlayer0: ref(null),
  refPlayer1: ref(null),
}

const state = reactive({
  aniBegin: false,
  aniEnd: false,
  rotate: 0,
  currentTop: 130,
  currentSize: 0,
  musicOpacity: 0,
  isPlay: 0,
  curPlayerData: "",
  currentUrl: "",
  fontSize: 24,
  musicData: [
    {
      duration_milliseconds: 128158,
      mp3_url: `/static/assets/music/ref.en.mp3`,
    },
    {
      duration_milliseconds: 28591,
      mp3_url: `/static/assets/music/gen.en.mp3`,
    },
  ],
})

const currentMusic = reactive({
  duration: 0,
  isplay: false,
  buffer: false,
  progress: 0,
  currentIndex: 0,
})

const doTogglePlay = (index) => {
  firebaseUtils.logClickEvent("audioref_subcribepage", {
    exampletype: index == 0 ? "reference" : "generated",
  })
  if (index == currentMusic.currentIndex) {
    stateData[`refPlayer${index}`].changeOp()
  } else {
    stateData[`refPlayer${index}`].changeOp(true)
  }
  currentMusic.currentIndex = index
}

const syncDuration = (duration) => {
  currentMusic.duration = duration
}

const syncPlayState = (playState, index) => {
  if (index == currentMusic.currentIndex) {
    currentMusic.isplay = playState
  }
}

const syncLoadingState = (loadingState) => {
  currentMusic.buffer = loadingState
}

const syncProgress = (progress) => {
  currentMusic.progress = progress
}

onMounted(() => {})
</script>
<style lang="scss" scoped>
.bk-small-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 50px;
  .bk-small-box-item {
    .audio-box {
      width: 200px;
      height: 200px;
      position: relative;
    }
  }
  .bkimg {
    width: 100%;
    height: 100%;
    background-image: url("@/assets/img/land/bk-play.webp");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    &.active {
      background-image: none;
      animation: breathing-animation 2s infinite;
      :deep(svg path) {
        animation: jitter 0.5s infinite;
      }
      :deep(svg path:nth-child(1)) {
        animation-delay: 0s;
      }
      :deep(svg path:nth-child(2)) {
        animation-delay: 0.1s;
      }
      :deep(svg path:nth-child(3)) {
        animation-delay: 0.2s;
      }
    }
  }
  @keyframes breathing-animation {
    0% {
      opacity: 0.3;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.3;
    }
  }
  .ic-music {
    width: 74px;
    height: 65px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-image: url("@/assets/img/land/ic_music.webp");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    &.ic-music-bk-1{
      background-image: url("@/assets/img/land/music-logo-pause.webp");
    }
    .ic-play-off {
      width: 56px;
      height: 56px;
      background-image: url("@/assets/img/land/ic-play.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-color: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
    }
    &.active {
      .ic-play-off {
        background-image: url("@/assets/img/land/ic-pause.png");
      }
    }
    &.music-2 {
      background-image: url("@/assets/img/land/music-logo-pause.webp");
    }
  }
  .music-desc {
    margin-top: 8px;
    padding: 8px 24px;
    text-align: center;
  }
}
.ani {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -35%);

  .indicator {
    position: absolute;
    z-index: 10;
    top: -30px;
    left: -100px;
    width: 2px;
    height: 384px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #e675ff 31%, #ffffff 49%, #4fdeff 67%, rgba(255, 255, 255, 0) 100%);
    .indi-mask {
      position: absolute;
      left: -100vw;
      z-index: 50;
      display: block;
      width: 100vw;
      height: 484px;

      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 1%, rgba(255, 255, 255, 0.05) 60%, rgba(255, 255, 255, 0) 100%);
      backdrop-filter: blur(32px);
    }
  }
  .bk-box {
    width: 340px;
    height: 340px;
    position: relative;

    .bk1x {
      position: absolute;
      width: 340px;
      height: 340px;
      left: 0;
      top: 0;
      background-image: url("@/assets/img/land/yuanouter.webp");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .bk2x {
      position: absolute;
      width: 212px;
      height: 212px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-image: url("@/assets/img/land/yuaninner.webp");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .music {
      position: absolute;
      width: 125px;
      height: 110px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-image: url("@/assets/img/land/ic_music.webp");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .pointer {
      position: absolute;
      left: 50%;
      width: 3px;
      height: 280px;
      background-image: url("@/assets/img/land/pointer.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      transform-origin: bottom center;
    }
  }
}

@media screen and (max-width: 768px) {
  .ani {
    top: 64%;
    .bk-box {
      width: 260px;
      height: 260px;
      .bk1x {
        width: 260px;
        height: 260px;
      }
    }
  }

  .bk-small-box {
    flex-direction: row;
    gap: 24px;
    padding: 20px 0;
    background: linear-gradient(302deg, #452b98 0%, #1f3992 100%);
    box-shadow: inset 0px 0px 60px 0px rgba(0, 0, 0, 0.3);
    .bk-small-box-item {
      .audio-box {
        width: 128px;
        height: 128px;
      }
    }
    .bk-small-box-item {
      margin-right: 0px;
    }
    .ic-music {
      width: 44px;
      height: 41px;

      .ic-play-off {
        width: 40px;
        height: 40px;
      }
    }
    .music-desc {
      font-size: 14px;
      font-weight: normal;
      padding: 0;
      text-align: center;
      margin-top: 12px;
    }
  }
}

@keyframes jitter {
  0%,
  100% {
    transform: translate(0, 0) rotate(0) scale(1);
    transform-origin: center;
  }
  25% {
    transform: translate(1px, -1px) rotate(1deg) scale(1.01);
    transform-origin: center;
  }
  50% {
    transform: translate(-1px, 1px) rotate(0) scale(1);
    transform-origin: center;
  }
  75% {
    transform: translate(1px, 1px) rotate(-1deg) scale(0.99);
    transform-origin: center;
  }
}
</style>
